import { useEscapeKey } from '../lib/useEscapeKey'

/**
 * Drop-in replacement for <div className="modal-overlay">.
 * Automatically closes the modal on Escape key press.
 * Pass onClick for optional click-outside-to-close behaviour.
 */
interface Props {
  onClose: () => void
  onClick?: React.MouseEventHandler<HTMLDivElement>
  children: React.ReactNode
}

export function ModalOverlay({ onClose, onClick, children }: Props) {
  useEscapeKey(onClose)
  return (
    <div className="modal-overlay" onClick={onClick}>
      {children}
    </div>
  )
}
